import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CREA NUOVO ESERCIZIO',
        description: 'Clicca sul bottone per creare un nuovo esercizio da zero.',
        isActive: true,
        name: 'CreateNewExerciseButton',
        tutorialName: 'crea-verifica_creazione_esercizio'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'left',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: -20,
        yOffset: 14
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: -20,
        yOffset: 14
    }
};
